module.exports = __webpack_public_path__ + "static/media/pdf.c966e803.svg";